"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  equipmentFee: {
    title: 'Inbound Container Fee',
    blNo: 'B/L No.',
    containerNo: 'Container No.',
    exportExcel: 'Export',
    tips_1: 'Warm Tips：',
    tips_2: '(1) The query results of this system are for reference only, and cannot be used as the basis for final payment; containers that cannot be searched for results do not represent no costs.',
    tips_3: '(2) This system only provides inquiries on demurrage and container repair fees. The yard fees, inspection fees,shifting charges and penalties that may occur at the terminal or yard after the container is overdue will be charged by the relevant unit according to relevant regulations.',
    tips_4: '(3) The demurrage fee is calculated based on the actual rates announced by SITC Co., Ltd. For specific rates and methods of collection, please contact the local agent of SITC Co., Ltd.',
    tips_5: '(4) The demurrage fee in red font，as of the unpaid container fee.',
    tips_6: '(5) The damaged pictures displayed on the page are all the damaged parts found during the yard inspection, and are not the items charged by customers.',
    tips_7: '(6) On the container repair fee page, please refer to the “Details” for the items that the yard checked which should be clients responsibility, and the actual bill sent by the local agent shall prevail.',
    tips_8: '(7) If you have any objection to the result of the repair fee, please contact our local inbound Equipment department.',
    DEMDETFeeTotal: 'Total DEM&DET：',
    repairFeeTotal: 'Total Repair：',
    DEMDETFee: 'Demurrage',
    repairFee: 'Repair',
    noData: ' is no data, Cannot export to Excel',
    DEMFee: 'DEM Fee',
    DETFee: 'DET Fee',
    containerType: 'Type',
    port: 'Port',
    startDate: 'Start Date',
    effectiveDate: 'Effective Date',
    endDate: 'End Date',
    freeDays: 'Free days',
    days: 'Days used',
    overDays: 'Expired days',
    amount: 'Amount',
    currency: 'Currency',
    ftNo: 'FTNo',
    demDetSum: 'Total usage days',
    totalSum: 'Total amount',
    sysEndDate: 'Calculate date in system',
    startDay: 'Start Day',
    endDay: 'End Day',
    containerInfo: 'Container Info',
    fixedCosts: 'Fixed costs',
    chargeByLevel: 'Charging List by Level',
    demuFreeDays: 'Demurrage Free days',
    detenFreeDays: 'Detention Free days',
    demTotal: 'DEM Total',
    detTotal: 'DET Total',
    repairPicture: 'Repair Picture',
    state: 'Status',
    total: 'Total',
    applying: 'Applying',
    approved: 'Approved',
    refuse: 'Refuse',
    underApproval: 'Under Approval',
    componentCode: 'Component',
    repairLocationCode: 'Position',
    damageCode: 'Damage',
    repairCode: 'Repair',
    applyType: 'Application Type',
    applyFee: 'Application Fee',
    applyDate: 'Application Date',
    repairFeeDetail: 'Repair Fee Detail',
    process: 'Application Process',
    derate: 'Derate',
    refund: 'Refund',
    detailInfo: 'Detail',
    info: 'Info',
    blNoInner: 'B/L No.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    containerNoInner: 'Container No.&nbsp;:&nbsp;',
    containerTypeInner: 'Type&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    amountInner: 'Amount&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    voyageRateInner: 'Voyage Rate&nbsp;&nbsp;:&nbsp;',
    stateInner: 'Status&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;',
    chargeFee: 'Electricity Charge',
    endDate1: 'End Date',
    rate: 'Rate',
    invoiceAmout: 'Paid',
    pickupDate: 'PickUp Date'
  }
};